module.exports = __webpack_public_path__ + "img/horizontal_3_4_9005.6fcbde36.png";